<template>
  <div>
    <!-- top -->
    <a-row class="chooseDate" type="flex" justify="space-around" align="middle">
      <a-col :span="10">
        <div class="name">
          余额：
        </div>
        <div>
          <a-spin :spinning="spinning" size="small">
            {{ "¥" + balanceAmount }}
          </a-spin>
        </div>
      </a-col>
      <a-col :span="14">
        <a-button type="" class="submitBtn downloadBtn" @click="backPage">
          返回
        </a-button>
      </a-col>
    </a-row>
    <!--  -->
    <div>
      <a-form :model="rechargeForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="充值项目：">
          <a-radio-group v-model:value="rechargeForm.business" button-style="solid" @change="changeBusiness">
            <a-radio-button value="10" class="createRechargItem">
              火车票
            </a-radio-button>
            <a-radio-button value="20" class="createRechargItem">
              酒店
            </a-radio-button>
            <a-radio-button value="30" class="createRechargItem">
              国际机票
            </a-radio-button>
            <a-radio-button value="40" class="createRechargItem">
              国内机票
            </a-radio-button>
            <a-radio-button value="50" class="createRechargItem">
              打车
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="充值金额：">
          <a-input v-model:value="rechargeForm.amount" style="width:60%" type="number" />
        </a-form-item>
        <a-form-item label="充值备注：">
          <a-textarea v-model:value="rechargeForm.remarks" style="width:60%" :auto-size="{ minRows: 2, maxRows: 5 }" />
        </a-form-item>
        <a-form-item class="error-infos" :wrapper-col="{ span: 14, offset: 2 }">
          <a-button type="primary" @click="goCharge" :loading="submitloading">
            去充值
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
import { reactive, ref, watch, createVNode } from "vue";
import { useRouter, useRoute } from "vue-router";
import myApi from "@axios/my";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import { CaretDownOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";

export default {
  name: "createRecharge",
  components: {
    CaretDownOutlined,
    ExclamationCircleOutlined
  },
  setup() {
    let router = useRouter();
    const route = useRoute();

    let rechargeForm = reactive({
      business: "10",
      amount: null,
      remarks: ""
    });
    let searchParams = reactive({
      business: ""
    });
    if (route.query.type == 1) {
      rechargeForm.business = route.query.business;
      searchParams.business = route.query.business;
    }

    let balanceAmount = ref("");
    let spinning = ref(false);

    // 查询余额
    const getBalance = () => {
      if (spinning.value) {
        return;
      }
      let params = {
        business: searchParams.business ? searchParams.business : null
      };
      spinning.value = true;
      myApi
        .getBalance(params)
        .then((res) => {
          balanceAmount.value = res;
          spinning.value = false;
        })
        .catch(() => {
          spinning.value = false;
        });
    };
    getBalance();

    const changeBusiness = () => {
      searchParams.business = rechargeForm.business;
      getBalance();
    };
    // 去充值
    let submitloading = ref(false);
    const goCharge = () => {
      let params = {
        business: searchParams.business,
        amount: rechargeForm.amount,
        remarks: rechargeForm.remarks,
        appPlatform: 10,
        returnUrl: window.location.origin + "/rechargeDetail"
      };
      submitloading.value = true;
      myApi
        .createRecharge(params)
        .then((res) => {
          console.log(res);
          submitloading.value = false;
          window.location.href = res.cashierUrl + "?advanceOrderNo=" + res.advanceOrderNo + "&type=train";
        })
        .catch(() => {
          submitloading.value = false;
        });
    };

    // 返回
    const backPage = () => {
      router.back();
    };

    return {
      rechargeForm,
      labelCol: { span: 2 },
      wrapperCol: { span: 14 },
      changeBusiness,
      spinning,
      balanceAmount,
      goCharge,
      submitloading,
      backPage
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.chooseDate {
  background: #f8f8f8;
  padding: 8px 22px 7px;
  margin-bottom: 12px;
  .ant-col-10 {
    text-align: left;
    .name {
      font-weight: 700;
    }
  }
  .ant-col-14 {
    text-align: right;
  }
  .submitBtn {
    background: #ffab00;
    border-color: #ffab00;
    margin-left: 17px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    border-radius: 4px;
  }
  .downloadBtn {
    background: #409eff !important;
    border-color: #409eff !important;
  }
}
.createRechargItem {
  margin-right: 8px;
}
</style>
